import NewGroupModal from './NewGroupModal';

export default NewGroupModal;
